var map = {
	"./event.js": 202,
	"./items.js": 643,
	"./screen.js": 644,
	"./snack-bar.js": 645
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 642;


//////////////////
// WEBPACK FOOTER
// ./src/reducers ^(.*\.(js$))[^.]*$/i
// module id = 642
// module chunks = 0